<app-background backgroundImage="images/shared/backgrounds/background-1.avif">
    <h1 class="sr-only">App Development Services — Native iOS, Android, Cross-Platform, and AI Mobile Apps</h1>
    <app-hero-section
        [backgroundImage]="`images/${file}/backgrounds/${file}.avif`"
        videoSrc="/video/app-development.mp4"
        align="left"
        [titleHtml]="heroTitleHtml"
        subcopy="From concept to code, we build powerful, scalable, and intuitive mobile apps that deliver exceptional user experiences and drive real business results."
        text="service">
        <app-button hero-cta buttonText="get in touch now!" (clicked)="scheduleCall()"></app-button>
    </app-hero-section>
    <app-lead-section [section]="introA"></app-lead-section>
    <hr appReveal class="section-divider" />
    <app-tag-services [section]="introB" marker="check"></app-tag-services>
    <hr appReveal class="section-divider" />
    <app-icon-section [section]="iosSection" iconSide="left"
        icon="images/app-development/platform/ios.png?v=2"></app-icon-section>
</app-background>

<app-background backgroundImage="images/shared/backgrounds/background-2.avif">
    <app-icon-section [section]="androidSection" iconSide="right"
        icon="images/app-development/platform/android.png?v=2"></app-icon-section>
    <hr appReveal class="section-divider" />
    <app-lead-section [section]="crossPlatformSection" [card]="true"></app-lead-section>
    <app-icon-section [section]="aiSection" iconSide="left"
        icon="images/app-development/platform/ai.png?v=2"></app-icon-section>
    <hr appReveal class="section-divider" />

    <app-info>
        <div class="flex flex-col justify-center items-center">
            <div class="font-outfit text-xl sm:text-3xl font-semibold mb-2 sm:mb-6">
                let's transform your business with <span class="gradient-text">ai-powered software</span>
            </div>
            <div class="font-inter mb-6 sm:mb-[21px] text-center text-sm sm:text-base">
                Ready to take your software to the next level? Tell us about your project and our team will show you
                what AI can do for it.<br><br>
                Discover what AI can do for your product. Contact SEM Nexus to get started.
            </div>
            <app-button buttonText="get in touch now!" (clicked)="scheduleCall()"></app-button>
        </div>
    </app-info>

    <!-- Related service: cross-link to mobile app strategy & implementation -->
    <div class="w-full mt-[80px] mb-[40px] px-4 sm:px-[10%]">
      <div class="adc-cta-wrap max-w-[900px] mx-auto">
        <div appReveal appSpotlight class="adc-cta-card r-rise rounded-[28px] p-8 sm:p-12 flex flex-col items-center text-center">
            <div class="font-outfit font-semibold text-2xl sm:text-3xl mb-4 lowercase">
                not sure where to start?
            </div>
            <div class="font-inter text-sm sm:text-base mb-7 max-w-[640px]">
                If you need to validate the idea, scope features, or build a roadmap before
                committing to a build, our <span class="gradient-text">mobile app strategy &amp; implementation</span> service is
                the right starting point.
            </div>
            <app-button buttonText="See mobile app strategy & implementation"
                (clicked)="goToConsulting()"></app-button>
        </div>
      </div>
    </div>
</app-background>

<app-background backgroundImage="images/shared/backgrounds/background-3.avif">
    <hr appReveal class="section-divider" />
    <app-tag-services [section]="uiuxSection" layout="center" marker="check"></app-tag-services>
    <hr appReveal class="section-divider" />
    <app-steps-section [section]="agileSection"></app-steps-section>
    <hr appReveal class="section-divider" />
    <app-lead-section [section]="whyChooseSection" layout="center"></app-lead-section>

    <div class="w-full mt-[40px] mb-[60px] px-4 sm:px-[10%]">
      <div class="adc-cta-wrap max-w-[900px] mx-auto">
        <div appReveal appSpotlight class="adc-cta-card r-rise rounded-[28px] p-8 sm:p-14 flex flex-col items-center text-center">
            <div class="font-outfit font-semibold text-2xl sm:text-3xl mb-4">
                development <span class="gradient-text">case studies</span>
            </div>
            <div class="font-inter text-sm sm:text-base mb-7 max-w-[600px]">
                See the <b>SEM Nexus</b> process in action. Join us and take a deep dive into our best development work.
            </div>
            <app-button buttonText="see all case studies" (clicked)="goToCaseStudies()"></app-button>
        </div>
      </div>
    </div>
    <app-connect></app-connect>
</app-background>
